import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 28345 28345"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke:#000;stroke-width:809.857;stroke-linecap:round;stroke-linejoin:round}.fil0{fill:none}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528319104752">
        <path
          d="M465 2331c630 3683 6179 6558 13331 6558 7091 0 13250-2821 14055-6454"
          className="fill-none stroke1"
          style={{
            strokeWidth: 809.857,
            strokeLinecap: "round",
          }}
        />
        <path
          d="M2841 2331c1274 2762 5675 4807 11331 4807 5657 0 10749-2045 12124-4807"
                    className="fill-none stroke1"
          style={{
            strokeWidth: 809.857,
            strokeLinecap: "round",
          }}

        />
        <path
          d="M6544 2331c1141 1715 3952 2931 7628 2931 3670 0 7112-1216 8394-2931"
                    className="fill-none stroke1"
          style={{
            strokeWidth: 809.857,
            strokeLinecap: "round",
          }}

        />
        <path
          d="M10154 2331c872 738 2281 1216 4099 1216s3616-485 4656-1216M405 405h27535v1926H405zM465 2331v25516M465 27847c1097-1226 1078-324 1811-807 734-484 61-1189 795-1672 735-484 1392 611 2127 128 735-484 78-1580 813-2064 735-483 1392 612 2127 128 737-485 80-1580 816-2065 737-485 1451 547 2187 63M2841 25397V6340M5616 24214V7524M8672 21608V8570M11141 21558V8806M27904 2423v25517M27904 27940c-641-1137-1078-325-1811-807-734-484-61-1189-795-1672-735-484-1392 611-2127 127s-78-1579-813-2063-1392 612-2128 127c-736-484-79-1580-815-2064-737-486-1451 547-2187 62M25528 25489V5774M22752 24306V7322M19697 21701V8663M17228 21650V8899"
                    className="fill-none stroke1"
          style={{
            strokeWidth: 809.857,
            strokeLinecap: "round",
          }}

        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
